import { render, staticRenderFns } from "./VStat.vue?vue&type=template&id=170dbb32&"
import script from "./VStat.vue?vue&type=script&lang=js&"
export * from "./VStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports